import React, { useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap';
import Products from '../products/Products';
import { useHistory } from 'react-router-dom';
import useWindowDimensions from '../../helpers/useWindowDimensions';
import CategoryLists from '../categorys/CategoryLists';
import UnitLists from '../units/UnitLists';

export default function StocksInfo() {

  const history = useHistory();
  const { height, width } = useWindowDimensions();
  const [shopId, setShopId] = useState()

  const handleSelect = (key) => {
    if (key === "/category" || key === "/unit") {
      const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
      setShopId(shopData?.id)
    }
    // history.push(key)
  };


  return (
    <div style={{ marginTop: width > 700 ? 0 : 50 }}>
      <Tabs
        defaultActiveKey="stocks"
        id="justify-tab-example"
        className="mb-3"
        justify={width > 700 ? false : true}
        onSelect={handleSelect}
      >
        <Tab eventKey="stocks" title="ຄັງສິນຄ້າ">
          <Products />
        </Tab>
        <Tab eventKey="/category" title="ປະເພດສິນຄ້າ">
          {shopId && <CategoryLists shopId={shopId} />}
        </Tab>
        <Tab eventKey="/unit" title="ຫົວໜ່ວຍ">
          {shopId && <UnitLists shopId={shopId} />}
        </Tab>
        <Tab eventKey="/brand" title="ແບຣນ ສິນຄ້າ">
          (ກຳລັງພັດທະນາ ຟັງຊັ່ນ ແບຣນ)
        </Tab>

      </Tabs>
    </div>
  )
}
